// extracted by mini-css-extract-plugin
export default {"f":"b3b62e7e4b","main":"_6087dfa994","btn":"c9b6102376","w":"e911486090","h":"e144bd72f2","lh25":"_49c43e08dd","wb":"b003a96c92","b":"_90b8c95e74","bx":"b352e7dd06"};